import type { ButtonHTMLAttributes, Ref } from 'react';

import BellIcon from '@cartwhl/ui/icons/BellIcon';
import Button from '@cartwhl/ui/input/Button';
import { HEADER_ICON_BUTTON_CLASSNAME } from '@cartwhl/ui/layout/StudioShellHeader';

export default function NotificationButton({
  showIndicator = false,
  appletHeader = false,
  ref,
  className,
  type = 'button',
  ...props
}: {
  showIndicator?: boolean;
  appletHeader?: boolean;
  ref?: Ref<HTMLButtonElement>;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>) {
  if (appletHeader) {
    return (
      <Button
        ref={ref}
        type={type}
        variant="secondary"
        size="sm"
        icon={<BellIcon />}
        iconSize={20}
        className={`relative overflow-visible p-1 ${showIndicator ? "after:bg-green after:h-3.25 after:w-3.25 after:pointer-events-none after:absolute after:-right-1 after:-top-1 after:rounded-full after:content-['']" : ''} ${className ?? ''}`}
        aria-label="Notifications"
        {...props}
      />
    );
  }

  return (
    <button
      ref={ref}
      type={type}
      className={`${HEADER_ICON_BUTTON_CLASSNAME} relative overflow-visible ${className ?? ''}`}
      aria-label="Notifications"
      {...props}
    >
      <BellIcon className="text-primary h-7 w-7" />
      {showIndicator ? (
        <span
          className="bg-green h-3.25 w-3.25 pointer-events-none absolute -right-1 -top-1 shrink-0 rounded-full"
          aria-hidden
        />
      ) : null}
    </button>
  );
}
